<template>
    <div align="center">
        <br><br><br><br><br>

        <h2><b>Mis anuncios</b></h2>
        <br>
        <a class="link" @click="$router.go(-1)" ><i class="fa fa-arrow-left" aria-hidden="true"></i>Regresar</a>

        <br><br>
        <h1 class="animate__animated animate__shakeY">
        <router-link id="agregar" :to="{name: 'productosAl', params:{autorizado:mailAutorizado}}" >
            <button class="button is-primary"  >    
                Agregar nuevo anuncio (Hasta 100 anuncios)
            </button> 
        </router-link></h1>
        <br>       
        <br>    


            <stripe-buy-button
              buy-button-id="buy_btn_1PbnsoDz9w3F7wpMrx2um6cv"
              publishable-key="pk_live_51ObyeVDz9w3F7wpMlSae9G9hu63TYm3DgrywEWQgM2LVVXhVrz7bQoGgESIjOvIQsmfle5xd76OhFzcz22FoEr4L00XYLNR21G"
            >
            </stripe-buy-button>


        <input type='text' placeholder='BUSCAR' v-if="cuantosAnuncios > 0" v-model='abuscar' >
        <br><br>

        <div id='productos-lista' v-if="productosTodos !=null"  align="center" >
 
            <div class="table-container"  v-if="cuantosAnuncios > 0">
                <table class="table is-narrow">
                    <thead>
                        <tr>
                            <th>Anuncio</th>
                            <th>Modificar</th>
                            <th>Visible</th>
                            <th>Liga pública para compartir</th>
                        </tr>
                    </thead>

                    <tbody class="tbody">
                        <tr v-for="productoi in buscando">
                            <td>
                              {{productoi.descripcion47}} / {{productoi.codigoInterno}}
                            </td>
                            <td>    
                                <router-link id="editar" :to="{name: 'productosEd', params:{id:productoi.folio47, mailAutorizado:mailAutorizado}}">
                                    Modificar
                                </router-link>
                            </td>
                            <td>
                                {{productoi.status47}}
                            </td>
                            <td >
                                <a @click="irA(productoi.micrositio)">{{vercadena(productoi.micrositio)}}</a>
                            </td>
                            <br>
                        </tr>
                    </tbody>
                </table>
                <br>
                <br>
                <br>
            </div>

        </div>

        <span v-else><b>Ud. no ha anunciado nada por ahora</b></span>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
          name: 'productos',
          mounted(){            
            this.getproductos();  
            if(this.mailAutorizado == null || this.mailAutorizado == '') this.$router.push('/');

          },
          props: ['mailAutorizado'], 
          data () {
            return {
              productosTodos: null,
              abuscar:'',
              cadena: '',
              numProducto:'',
              cualProductoEs:'',
              cuantosAnuncios: 0
            }
          },
          methods:{
            getproductos(){
                axios.get('https://www.rentas-ventas.com/leeProductos.php?usu50=' + this.mailAutorizado)
                     .then((respuesta) => {

                        this.productosTodos = respuesta.data;
                        this.cuantosAnuncios = new Blob([JSON.stringify(respuesta.data)]).size;
                     });
            },
            vercadena(nombre){
                return "www.rentas-ventas.com?" + nombre ;
            },
            irA(aDonde){
                window.open('https://www.rentas-ventas.com?' + aDonde, '_blank');
            }
            
          },

          computed:{
                buscando: function (){
                    return this.productosTodos.filter((item) =>  
                        item.descripcion47.toUpperCase().includes(this.abuscar.toUpperCase()) 
                     || item.codigoInterno.toUpperCase().includes(this.abuscar.toUpperCase())
                    );
                }
          }

    };

</script>

<style lang="scss">    

</style>




// WEBPACK FOOTER //
// src/Productos-Mios.vue